import { render, staticRenderFns } from "./warehouse-pie.vue?vue&type=template&id=024a8b6f&scoped=true&"
import script from "./warehouse-pie.vue?vue&type=script&lang=js&"
export * from "./warehouse-pie.vue?vue&type=script&lang=js&"
import style0 from "./warehouse-pie.vue?vue&type=style&index=0&id=024a8b6f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "024a8b6f",
  null
  
)

export default component.exports